import SelectionTreeNodeRenderer from "../selectionTree/SelectionTreeNodeRenderer";
import {disableTextSelection} from "../../atBrowserUtils";

export default class TriStateCheckboxTreeNodeRenderer extends SelectionTreeNodeRenderer {
    constructor(tree) {
        super(tree);
    }

    generateContent(treeNode, targetEl) {
        const triStateEl = document.createElement("a");
        triStateEl.hidefocus = "true";
        triStateEl.onfocus = function() { this.blur() };
        const context = this;
        if (this.tree.selectionController.canSelectNode(treeNode) && this.tree.selectionController.canDeselectNode(treeNode)) {
            triStateEl.onclick = function() {
                context.tree.getSelectionController().toggle(treeNode);

                // if some node is selected/deselected inside a collapsed node,
                // then it would be smart to expand the outer node automatically,
                // so I can see my changes even after I cancel keyword search.
                const parentNode = treeNode.getParent();
                if (parentNode && (context.tree.isRootVisible() || parentNode.getLevel() > 0))
                    context.tree.getExpandController().expand(parentNode);
            };
        }
        disableTextSelection(triStateEl, true);

        const checkbox = document.createElement("span");
        checkbox.className = "checkbox";
        checkbox.innerHTML = "<b></b>"; // for IE to display it correctly

        const labelEl = document.createElement("span");
        labelEl.className = "ellipsisLabel";
        targetEl.appendChild(triStateEl);
        triStateEl.appendChild(checkbox);
        triStateEl.appendChild(labelEl);
        this.generateLabel(treeNode, labelEl);

        this.appendAdditionalElements(targetEl, treeNode);

        this.tree.getUIObjectForNode(treeNode).cbEl = triStateEl;
        this.tree.getUIObjectForNode(treeNode).labelEl = labelEl;
    }

    appendAdditionalElements(targetEl, treeNode) {
        // do nothing by default
    }

    //  abstract
    generateLabel(treeNode, labelEl) {
    }

    updateLabel(treeNode) {
        const uiObject = this.tree.getUIObjectForNode(treeNode)
        if (uiObject.labelEl) {
            this.generateLabel(treeNode, uiObject.labelEl);
        }
    }

    updateUI(treeNode) {
        const uiObject = this.tree.getUIObjectForNode(treeNode)
        if (uiObject.cbEl) {
            const selectionController = this.tree.getSelectionController();

            let className = "triState";
            if (selectionController.isSelected(treeNode))
                className += " checked";
            else if (selectionController.containsSelectedChildren(treeNode))
                className += " intermediate";

            if (!this.tree.selectionController.canSelectNode(treeNode) || !this.tree.selectionController.canDeselectNode(treeNode)) {
                className += " selectionDisabled";
            } else {
                className += " selectionEnabled";
            }

            uiObject.cbEl.className = className;
        }

        super.updateUI(treeNode);
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/TriStateCheckboxTreeNodeRenderer.js